<template>
  <in-view
    :threshold="thresholdHeading"
    :threshold-type="'px'"
    class="slide-into-view-transition"
  >
    <h2
      :id="anchorLink"
      v-edit="`${vEditHeading}`"
      class="section-heading-name"
    >
      {{ heading }}
      <span
        v-if="count > 0"
        class="font-rubrik-1--light"
      >({{ count }})</span>
    </h2>
  </in-view>
</template>

<script>
  export default {
    name: 'SubHeading',
    props: {
      heading: {
        type: String,
        default: ""
      },
      count: {
        type: Number,
        default: 0
      },
      anchorLink: {
        type: String,
        default: ""
      },
      vEditHeading: {
        type: String,
        default: ""
      }
    },
    computed: {
      thresholdHeading () {
        return this.$root.isLargeViewport ? 32: 28
      }
    }
  }
</script>
